import React, { Component } from 'react';
import propsTypes from 'prop-types';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { registerUser, loginUser, logoutUser } from '../actions/userActions';

class Header extends Component {

  constructor(props) {
    super(props);
    this.state = {
      show: false,
      isRegister: true,
    };
    this.handleLogoutClick = this.handleLogoutClick.bind(this);
    this.handleLoginClick = this.handleLoginClick.bind(this);
    this.handleRegisterClick = this.handleRegisterClick.bind(this);
  }

  handleLogoutClick() {
    this.props.logoutUser();
    this.props.history.push('/');
  }

  handleLoginClick() {
    this.props.history.push('/user_login')
  }

  handleRegisterClick() {
    this.props.history.push('/user_register')
  }
  
  render() {
    return (
        <div>
        <small className="userinfo">
          {((Object.keys(this.props.userinfo) !== 0) && ('token' in this.props.userinfo)) ?
            (<span>欢迎您，{this.props.userinfo.username}&nbsp;<a nohref="true" onClick={this.handleLogoutClick}>注销</a></span>)
            :
            (<span>请<a nohref="true" onClick={this.handleLoginClick} >登录</a>或<a nohref="true" onClick={this.handleRegisterClick} >注册</a></span>)
          }
        </small>
        <h2>在线错题本</h2>
        <p><small>基于知识点的错题管理系统。</small></p>
        </div>
    )
  }
}

Header.propsTypes = {
  loginUser: propsTypes.func.isRequired,
  logoutUser: propsTypes.func.isRequired,
  registerUser: propsTypes.func.isRequired,
  userinfo: propsTypes.object,
  validity: propsTypes.object,
}

const mapStateToProps = state => ({
  userinfo: state.users.item,
})

export default withRouter(
  connect(
    mapStateToProps,
    { loginUser, logoutUser, registerUser }
  )(Header));



// WEBPACK FOOTER //
// ./src/components/Header.js